module.exports = __webpack_public_path__ + "img/exc.7487b7bb.png";